import { useEffect, useRef } from 'react';
const defaultEvents = [
    'mousedown',
    'touchstart',
];
const useClickAway = (props) => {
    const { checkIsOutside, onClickAway, events = defaultEvents } = props;
    const savedOnClickAway = useRef(onClickAway);
    const savedCheckIsOutside = useRef(checkIsOutside);
    useEffect(() => {
        savedOnClickAway.current = onClickAway;
    }, [onClickAway]);
    useEffect(() => {
        savedCheckIsOutside.current = checkIsOutside;
    }, [checkIsOutside]);
    useEffect(() => {
        const handler = (event) => {
            if (savedCheckIsOutside.current(event)) {
                savedOnClickAway.current(event);
            }
        };
        events.forEach(event => {
            document.addEventListener(event, handler);
        });
        return () => {
            events.forEach(event => {
                document.removeEventListener(event, handler);
            });
        };
    }, [events]);
};
export default useClickAway;
//# sourceMappingURL=useClickAway.js.map